export default __webpack_public_path__ + "static/media/chef-king.294c772c.svg";